// Asynchronously import needed polyfills for the browser
export async function loadPolyfills() {
  // Smoothscroll polyfill is needed for Safari to allow behavior: 'smooth' in window.scrollTo
  if (!('scrollBehavior' in document.documentElement.style)) {
    const smoothscroll = await import(/* webpackChunkName: "smoothscroll-polyfill" */ 'smoothscroll-polyfill');
    smoothscroll.polyfill();
  }
}
